const ZDANIA80 = [
{
    name: "Angielski Grudzień 2025",
    lang: 'en',
    zdania: [
      {
        pl: "adoptowany",
        de: "adopted"
      },
      {
        pl: "ciocia",
        de: "aunt"
      },
      {
        pl: "szwagier",
        de: "brother-in-law"
      },
      {
        pl: "kuzyn/kuzynka",
        de: "cousin"
      },
      {
        pl: "teść",
        de: "father-in-law"
      },
      {
        pl: "wnuki",
        de: "grandchildren"
      },
      {
        pl: "wnuczka",
        de: "granddaughter"
      },
      {
        pl: "dziadek",
        de: "grandfather"
      },
      {
        pl: "babcia",
        de: "grandmother"
      },
      {
        pl: "dziadkowie",
        de: "grandparents"
      },
      {
        pl: "wnuk",
        de: "grandson"
      },
      {
        pl: "prawnuki",
        de: "great-grandchildren"
      },
      {
        pl: "pradziadkowie",
        de: "great-grandparents"
      },
      {
        pl: "brat przyrodni",
        de: "half-brother"
      },
      {
        pl: "siostra przyrodnia",
        de: "half-sister"
      },
      {
        pl: "mąż",
        de: "husband"
      },
      {
        pl: "teściowa",
        de: "mother-in-law"
      },
      {
        pl: "siostrzeniec / bratanek",
        de: "nephew"
      },
      {
        pl: "siostrzenica / bratanica",
        de: "niece"
      },
      {
        pl: "jedynak / jedynaczka",
        de: "only child"
      },
      {
        pl: "rodzice",
        de: "parents"
      },
      {
        pl: "krewny",
        de: "relative"
      },
      {
        pl: "rodzeństwo",
        de: "sibling"
      },
      {
        pl: "szwagierka / bratowa",
        de: "sister-in-law"
      },
      {
        pl: "ojczym",
        de: "stepfather"
      },
      {
        pl: "macocha",
        de: "stepmother"
      },
      {
        pl: "bliźnięta",
        de: "twins"
      },
      {
        pl: "wujek",
        de: "uncle"
      },
      {
        pl: "żona",
        de: "wife"
      },
      {
        pl: "dorosły",
        de: "adult"
      },
      {
        pl: "w wieku 14 lat",
        de: "at the age of 14"
      },
      {
        pl: "urodzić się",
        de: "be born"
      },
      {
        pl: "narodziny",
        de: "birth"
      },
      {
        pl: "dzieciństwo",
        de: "childhood"
      },
      {
        pl: "śmierć",
        de: "death"
      },
      {
        pl: "umrzeć",
        de: "die"
      },
      {
        pl: "w podeszłym wieku",
        de: "elderly"
      },
      {
        pl: "dorastać",
        de: "grow up"
      },
      {
        pl: "nastolatek / nastolatka",
        de: "teenager"
      },
      {
        pl: "sprzątać pokój",
        de: "clean / tidy your room"
      },
      {
        pl: "odrabiać lekcje",
        de: "do homework"
      },
      {
        pl: "sprzątać",
        de: "do the cleaning"
      },
      {
        pl: "gotować",
        de: "do the cooking"
      },
      {
        pl: "wykonywać prace domowe",
        de: "do the housework"
      },
      {
        pl: "robić zakupy",
        de: "do the shopping"
      },
      {
        pl: "odkurzać",
        de: "do the vacuuming"
      },
      {
        pl: "robić pranie",
        de: "do the washing"
      },
      {
        pl: "prać ubrania",
        de: "wash your clothes"
      },
      {
        pl: "zmywać naczynia / myć naczynia",
        de: "do the washing-up / wash the dishes"
      },
      {
        pl: "ubierać się",
        de: "get dressed"
      },
      {
        pl: "szykować się do szkoły",
        de: "get ready for school"
      },
      {
        pl: "wstawać",
        de: "get up"
      },
      {
        pl: "jechać do szkoły (autobusem)",
        de: "go to school by (bus)"
      },
      {
        pl: "jeść śniadanie / posiłek",
        de: "have breakfast / a meal"
      },
      {
        pl: "brać kąpiel",
        de: "take a bath"
      },
      {
        pl: "brać prysznic",
        de: "take a shower"
      },
      {
        pl: "nakrywać do stołu",
        de: "lay the table"
      },
      {
        pl: "ładować / rozładowywać zmywarkę",
        de: "load / empty the dishwasher"
      },
      {
        pl: "opiekować się kimś",
        de: "look after sb"
      },
      {
        pl: "ścielić łóżko",
        de: "make your bed"
      },
      {
        pl: "opiekować się zwierzętami domowymi",
        de: "take care of pets"
      },
      {
        pl: "wynosić śmieci",
        de: "take out the rubbish"
      },
      {
        pl: "porządkować biurko",
        de: "tidy the desk"
      },
      {
        pl: "budzić się",
        de: "wake up"
      },
      {
        pl: "wyprowadzać psa",
        de: "walk the dog"
      },
      {
        pl: "myć samochód",
        de: "wash the car"
      },
      {
        pl: "organizować życie towarzyskie",
        de: "arrange social life"
      },
      {
        pl: "interesować się czymś",
        de: "be interested in sth"
      },
      {
        pl: "interesować się czymś",
        de: "be into sth"
      },
      {
        pl: "lubić coś",
        de: "be keen on sth"
      },
      {
        pl: "porabiać coś",
        de: "be up to sth"
      },
      {
        pl: "czatować na Facebooku",
        de: "chat on Facebook"
      },
      {
        pl: "uprawiać sport",
        de: "do sport"
      },
      {
        pl: "pracować społecznie jako wolontariusz",
        de: "do voluntary work"
      },
      {
        pl: "dobrze się bawić",
        de: "have a good time"
      },
      {
        pl: "rozrywka",
        de: "entertainment"
      },
      {
        pl: "iść na spacer",
        de: "go for a walk"
      },
      {
        pl: "wychodzić (np. do kina, restauracji)",
        de: "go out"
      },
      {
        pl: "pójść potańczyć / na kręgle / pobiegać",
        de: "go dancing / bowling / jogging"
      },
      {
        pl: "spędzać czas w internecie",
        de: "go / spend time online"
      },
      {
        pl: "iść do kina",
        de: "go to the cinema"
      },
      {
        pl: "spędzać z kimś czas, trzymać się z kimś",
        de: "hang out with sb"
      },
      {
        pl: "być z kimś w kontakcie",
        de: "keep in touch with sb"
      },
      {
        pl: "grać w gry planszowe / szachy",
        de: "play board games / chess"
      },
      {
        pl: "dzielić się zdjęciami, udostępniać zdjęcia",
        de: "share photos"
      },
      {
        pl: "rozmawiać na Skype",
        de: "Skype"
      },
      {
        pl: "serwis społecznościowy",
        de: "social networking site"
      },
      {
        pl: "spotykać się / spędzać czas z",
        de: "socialise with"
      },
      {
        pl: "spędzać czas na powietrzu",
        de: "spend time outdoors"
      }
    ]
}
]





const ZDANIA81 = [
  {
    name: "Angielski Grudzień - 2 2025",
    lang: 'en',
    zdania: [
      {
        pl: "poprosić kogoś (aut)",
        de: "ask sb out"
      },
      {
        pl: "zerwać (np. z kimś)",
        de: "break up"
      },
      {
        pl: "dopingować kogoś",
        de: "cheer sb up"
      },
      {
        pl: "umawiać się / randka",
        de: "date"
      },
      {
        pl: "pierścionek zaręczynowy",
        de: "engagement ring"
      },
      {
        pl: "zakochać się (w kimś)",
        de: "fall in love (with sb)"
      },
      {
        pl: "narzeczony/narzeczona",
        de: "fiancé/fiancée"
      },
      {
        pl: "konflikt pokoleniowy",
        de: "generation gap"
      },
      {
        pl: "zaręczyć się",
        de: "get engaged"
      },
      {
        pl: "pobrać się / wziąć ślub",
        de: "get married / marry sb"
      },
      {
        pl: "poznać kogoś",
        de: "meet"
      },
      {
        pl: "pobić się / poślubić kogoś",
        de: "marry"
      },
      {
        pl: "dogadywać się z kimś",
        de: "get on well with sb"
      },
      {
        pl: "relacja z kimś",
        de: "relationship"
      },
      {
        pl: "poznawać kogoś",
        de: "get to know sb"
      },
      {
        pl: "samotny rodzic",
        de: "single parent"
      },
      {
        pl: "chodzić z kimś",
        de: "go out with sb"
      },
      {
        pl: "obrączka ślubna",
        de: "wedding ring"
      },
      {
        pl: "miesiąc miodowy",
        de: "honeymoon"
      },
      {
        pl: "przedstawić się/kogoś (komuś)",
        de: "introduce yourself/sb (to sb)"
      },
      {
        pl: "małżeństwo",
        de: "marriage"
      },
      {
        pl: "para małżeńska",
        de: "married couple"
      },
      {
        pl: "poznać kogoś",
        de: "meet sb"
      },
      {
        pl: "w ciąży",
        de: "pregnant"
      },
      {
        pl: "oświadczyć się komuś",
        de: "propose to sb"
      },
      {
        pl: "związek",
        de: "relationship"
      },
      {
        pl: "kawaler / panna",
        de: "single person"
      },
      {
        pl: "ślub",
        de: "wedding"
      },
      {
        pl: "rocznica ślubu",
        de: "wedding anniversary"
      },
      {
        pl: "wesele",
        de: "wedding reception"
      },
      {
        pl: "Wszystkich Świętych",
        de: "All Saints' Day"
      },
      {
        pl: "obchodzić, świętować",
        de: "celebrate"
      },
      {
        pl: "uroczystość, obchody, świętowanie",
        de: "celebration"
      },
      {
        pl: "cmentarz",
        de: "cemetery"
      },
      {
        pl: "Dzień Dziecka",
        de: "Children's Day"
      },
      {
        pl: "Święta Bożego Narodzenia",
        de: "Christmas"
      },
      {
        pl: "kartka bożonarodzeniowa/wielkanocna",
        de: "Christmas/Easter card"
      },
      {
        pl: "pierwszy dzień świąt Bożego Narodzenia",
        de: "Christmas Day"
      },
      {
        pl: "Wigilia",
        de: "Christmas Eve"
      },
      {
        pl: "ubierać choinkę",
        de: "decorate the Christmas tree"
      },
      {
        pl: "Wielkanoc",
        de: "Easter"
      },
      {
        pl: "zajączek wielkanocny",
        de: "Easter Bunny"
      },
      {
        pl: "składać sobie życzenia",
        de: "exchange wishes"
      },
      {
        pl: "święto",
        de: "festival/holiday"
      },
      {
        pl: "pokaz fajerwerków",
        de: "fireworks display"
      },
      {
        pl: "pogrzeb",
        de: "funeral"
      },
      {
        pl: "gość",
        de: "guest"
      },
      {
        pl: "zaproszenie",
        de: "invitation"
      },
      {
        pl: "zaprosić",
        de: "invite"
      },
      {
        pl: "Dzień Matki/Ojca",
        de: "Mother's/Father's Day"
      },
      {
        pl: "imieniny",
        de: "name day"
      },
      {
        pl: "Nowy Rok",
        de: "New Year's Day"
      },
      {
        pl: "sylwester",
        de: "New Year's Eve"
      },
      {
        pl: "dzielić się opłatkiem",
        de: "share Christmas wafers"
      },
      {
        pl: "odwiedzać groby",
        de: "visit graves"
      },
      {
        pl: "wesele",
        de: "wedding"
      },
      {
        pl: "rocznica ślubu",
        de: "wedding anniversary"
      },
      {
        pl: "przyjęcie weselne",
        de: "wedding reception"
      },
      {
        pl: "zgodzić się z",
        de: "agree with"
      },
      {
        pl: "przepraszać (kogoś) za (coś)",
        de: "apologise to (sb) for (sth)"
      },
      {
        pl: "kłócić się z",
        de: "argue with"
      },
      {
        pl: "prosić o pieniądze",
        de: "ask for money"
      },
      {
        pl: "pożyczać od",
        de: "borrow from"
      },
      {
        pl: "zerwać z",
        de: "break up with"
      },
      {
        pl: "skarżyć się na",
        de: "complain about"
      },
      {
        pl: "krytykować czyjeś zachowanie",
        de: "criticise sb's behaviour"
      },
      {
        pl: "pokłócić się, poróżnić się z",
        de: "fall out with"
      },
      {
        pl: "wpaść w depresję, wpaść w depresję",
        de: "get depressed"
      },
      {
        pl: "denerwować się",
        de: "get divorced"
      },
      {
        pl: "wpaść w nerwus",
        de: "get on sb's nerves"
      },
      {
        pl: "pokłócić się z",
        de: "have a fight / an argument with"
      },
      {
        pl: "pożyczać (komuś) pieniądze",
        de: "lend money to (sb)"
      },
      {
        pl: "pogodzić się z",
        de: "make up with"
      },
      {
        pl: "uciec",
        de: "run away"
      },
      {
        pl: "rozstać się",
        de: "separate"
      },
      {
        pl: "zerwać z kimś",
        de: "split up with"
      },
      {
        pl: "wymieniać",
        de: "exchange"
      },
      {
        pl: "dowiedzieć się",
        de: "find out"
      },
      {
        pl: "podążać za; śledzić",
        de: "follow"
      },
      {
        pl: "odżywianie, żywienie, dietetyka",
        de: "nutrition"
      },
      {
        pl: "ssać kotek",
        de: "suck a thumb"
      },
      {
        pl: "wkładać, chować",
        de: "tuck"
      },
      {
        pl: "jedynaczka (dziewczynka)",
        de: "only child (female)"
      },
      {
        pl: "dziadkowie",
        de: "grandparents"
      },
      {
        pl: "gra planszowa",
        de: "board game"
      },
      {
        pl: "miesiąc miodowy",
        de: "honeymoon"
      },
      {
        pl: "odczasownikowy rzeczownik",
        de: "verbal noun"
      },
      {
        pl: "prawo jazdy",
        de: "driving licence"
      },
      {
        pl: "przymiotnikowe",
        de: "adjectival noun"
      },
      {
        pl: "teściowa",
        de: "mother-in-law"
      }
    ]
  }
]

export { ZDANIA80, ZDANIA81 }